import React, { useState } from 'react';
import { connect } from 'react-redux';

import { workflowRemoveQuestion } from '~/actions/workflow';
import ActionsMenu from '~/components/Shared/ActionsMenu/ActionsMenu';
import ConditionRulePill from '~/components/Workflow/shared/ConditionRulePill';
import FieldPill from '~/components/Workflow/shared/FieldPill';
import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import { getFieldById } from '~/reducers/workflow';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

import QuestionEditable from './QuestionEditable';

function Question({
  question,
  sectionId,
  onReorder,
  // connected,
  field,
  workflowRemoveQuestion,
}) {
  const intl = useIntl();
  const [editMode, setEditMode] = useState(!field?.id);

  function handleOnClose() {
    setEditMode(false);
  }

  if (editMode) {
    return (
      <QuestionEditable
        position={question.position}
        question={question}
        sectionId={sectionId}
        onClose={handleOnClose}
        onReorder={onReorder}
      />
    );
  }

  const { conditionRule, description, id, isRequired, name } = question;

  const getMenuItems = () => {
    const items = [];

    items.push({
      content: intl.formatMessage({
        id: 'Question.reorderQuestions',
        defaultMessage: 'Reorder Questions',
        description: 'Menu item to reorder questions',
      }),
      onClick: () => onReorder(),
    });

    items.push({
      content: intl.formatMessage({
        id: 'Question.deleteQuestion',
        defaultMessage: 'Delete Question',
        description: 'Menu item to delete a question',
      }),
      onClick: () => workflowRemoveQuestion({ sectionId, questionId: id }),
    });

    return items;
  };

  return (
    <FlexLayout flexDirection="column" key={id}>
      <FlexLayout alignItems="center" space={2}>
        <Text variant="m-dense-bold" sx={{ flexGrow: 1 }}>
          {name}
          {isRequired && ' *'}
        </Text>
        <FlexLayout alignItems="center" flexShrink="0" space={2}>
          <Button
            text={intl.formatMessage({
              id: 'Question.editButton',
              defaultMessage: 'Edit',
              description: 'Edit button text',
            })}
            variant="action"
            onClick={() => setEditMode(true)}
          />
          <ActionsMenu
            id={`workflow_builder_form_question_actions_menu_id=${id}`}
            items={getMenuItems()}
            align="end"
          />
        </FlexLayout>
      </FlexLayout>
      <FlexLayout flexDirection="column" space={4}>
        {description && (
          <Text variant="xs-dense-medium" color="gray-600">
            {description}
          </Text>
        )}
        <FlexLayout space={2}>
          <FieldPill fieldId={question.fieldId} />
          <ConditionRulePill conditionRule={conditionRule} />
        </FlexLayout>
      </FlexLayout>
    </FlexLayout>
  );
}

const mapStateToProps = ({ workflow }, { question }) => ({
  // TODO: @zixu to figure out how to write a selector that checks a question.
  //       field and returns if field/condition is valid without having to remap
  //       conditions/fields to props.
  conditions: workflow.conditions,
  fields: workflow.fields,
  field: question ? getFieldById(workflow, question.fieldId) : {},
});

export default connect(mapStateToProps, { workflowRemoveQuestion })(Question);
